import { useMemo } from "react"

import { Button, Select } from "@productlane/ui"

interface ColumnStepProps {
	data: string[][]
	hasHeaders: boolean
	back: () => void
	next: () => void
	textIndex: number
	setTextIndex: (i: number) => void
	sortedData: string[][]
}

export function ColumnStep({
	data,
	hasHeaders,
	back,
	next,
	textIndex,
	setTextIndex,
	sortedData,
}: ColumnStepProps) {
	const headers = useMemo(() => {
		if (!data[0]) {
			return []
		}
		if (hasHeaders) {
			return data[0].map((it, i) => ({
				label: it,
				value: i.toString(),
			}))
		}
		return data[0].map((_, i) => ({
			label: `${i + 1}. Column`,
			value: i.toString(),
		}))
	}, [hasHeaders, data])

	return (
		<div>
			<Select
				value={textIndex.toString()}
				name="textIndex"
				label="Select the column with the notes text"
				options={headers}
				onChange={(it) => setTextIndex(Number(it))}
			/>

			<div className="mt-4 text-sm text-primary">Preview:</div>
			<div className="relative mt-1 overflow-hidden rounded-lg border bg-white p-2 dark:bg-gray-900">
				{sortedData[textIndex]
					?.slice(hasHeaders ? 1 : 0, hasHeaders ? 5 : 4)
					.map((it, i) => (
						<div className="truncate border-b p-1 text-xs text-primary" key={i}>
							{it}
						</div>
					))}
				<div className="absolute inset-x-0 bottom-0 h-[80%] bg-gradient-to-b from-transparent via-white/80 to-white dark:via-brand-900/80 dark:to-brand-900" />
			</div>

			<div className="mt-2 flex justify-between">
				<Button variant="link" onClick={back}>
					Back
				</Button>
				<Button onClick={next}>Select</Button>
			</div>
		</div>
	)
}
